/**
 * # isTest
 * Constant in the sharedModule. It's set to true only during jasmine tests;
 * otherwise should be equal to false.
 */
export type IsTest = boolean;
export const IsTestProvider = {
  provide: 'isTest',
  useValue: false,
};
